import { render, staticRenderFns } from "./AdditionalComponentsInvoice.vue?vue&type=template&id=5c99873f&scoped=true&"
import script from "./AdditionalComponentsInvoice.vue?vue&type=script&lang=js&"
export * from "./AdditionalComponentsInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c99873f",
  null
  
)

export default component.exports